import { render, staticRenderFns } from "./historial.vue?vue&type=template&id=2c8df3f8&scoped=true"
import script from "./historial.vue?vue&type=script&lang=js"
export * from "./historial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8df3f8",
  null
  
)

export default component.exports